import React from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "@foris/avocado-suite";
import { useVacanciesStore } from "./contextVacancies/useVacanciesStore";
import css from "./vacancies.module.scss";

interface IFooterVacancies {
  activeEdit: boolean;
  setActiveEdit: (active: boolean) => void;
  warningsCount: number;
  canEnterEdit: boolean;
  onSave: (commit: boolean) => void;
  disabledConfirm?: boolean;
  isSaveValid?: boolean;
  onBlockedExit?: () => void;
}

const FooterVacancies: React.FC<IFooterVacancies> = (props: IFooterVacancies) => {
  const {
    activeEdit,
    setActiveEdit,
    warningsCount,
    onSave,
    disabledConfirm,
    canEnterEdit,
    isSaveValid,
    onBlockedExit,
  } = props;
  const allChangesAreValid = useVacanciesStore(state => state.allChangesAreValid);
  const changesAreValid = isSaveValid ?? allChangesAreValid;

  const { t } = useTranslation();
  const history = useHistory();

  return (
    <footer className={cx(css.footer, "container-row")}>
      {!activeEdit && (
        <>
          <Button
            variant="ghost"
            onClick={() => {
              if (onBlockedExit) onBlockedExit();
              else history.goBack();
            }}
          >
            {t("bundle.actions.back")}
          </Button>
          {canEnterEdit && (
            <Button
              onClick={() => {
                setActiveEdit(true);
              }}
            >
              {t("bundle.actions.edit")}
            </Button>
          )}
        </>
      )}
      {activeEdit && (
        <>
          <Button
            variant="ghost"
            onClick={() => {
              if (onBlockedExit) onBlockedExit();
              else setActiveEdit(false);
            }}
          >
            {t("bundle.actions.cancel")}
          </Button>
          {warningsCount === 0 && (
            <Button
              disabled={!changesAreValid}
              onClick={() => {
                onSave(false);
              }}
            >
              {t("bundle.actions.save-changes")}
            </Button>
          )}
          {warningsCount > 0 && (
            <Button
              disabled={disabledConfirm || !changesAreValid}
              onClick={() => {
                onSave(true);
              }}
            >
              {t("bundle.actions.confirm-changes")}
            </Button>
          )}
        </>
      )}
    </footer>
  );
};

export default FooterVacancies;
